import { Immutable } from "immer";
import React from "react";

import type { WarrantyFrame as Value } from "@reactivated";

type IProps = Immutable<{
    value: Value | null;
}>;

/**
 * Renders the warranty iframe. The block is a value-less StaticBlock: the
 * serialized value is an empty object (or null) and is ignored.
 */
export const WarrantyFrame = (_props: IProps): React.JSX.Element => {
    return (
        <iframe
            width="100%"
            height="900px"
            scrolling="auto"
            frameBorder="0"
            src="https://registration.sealy.com/productwarrantyclaim.aspx"
            className="externalAppIFrame"
            id="main_1_content_0_externalAppIFrame"
        ></iframe>
    );
};
